import styled from 'styled-components';

const Indicator = styled.i`
  font-size: 16px;
`;

export default Indicator;
